import request from '@/utils/request2'

// 列表(主数据列表)
export function loadExternalEmployeeListDataApi(data) {
  return request({
    url: 'tms-web/externalEmployee/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportExternalEmployeeListDataApi(data) {
  return request({
    url: 'tms-web/externalEmployee/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveExternalEmployeeApi(data) {
  return request({
    url: 'tms-web/externalEmployee/save',
    method: 'post',
    data
  })
}

// 变更状态
export function updateStatusExternalEmployeeApi(data) {
  return request({
    url: 'tms-web/externalEmployee/updateStatus',
    method: 'post',
    data
  })
}

// 查看
export function viewExternalEmployeeApi(data) {
  return request({
    url: 'tms-web/externalEmployee/view',
    method: 'post',
    data
  })
}

// 列表
export function listExternalEmployeeApi(data) {
  return request({
    url: 'tms-web/externalEmployee/list',
    method: 'post',
    data
  })
}
